import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const redirect = createAsyncThunk('redirect/redirect', async (data) => {
    const { short_code } = data;
    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `redirect`,
            params: {
                short_code: short_code,
                user_name: localStorage.getItem("user_name")

            },
            headers: { "Content-Type": "application/json" },
        })
        return res
    } catch (error) {
        return error.response
    }
})

